import AbsModule from '../common/AbsModule';
import NotiSetting from './NotiSetting';
import api from '../notice/notiApi';
import { getJsonp } from '../service/fetchJsonp';

class Noti extends AbsModule {
    startSetting() {
        const btnSetting = document.querySelector('#nc-cnb .ncc-noti-list .wrap_btns button.btnSetting');
        
        this._notisetting = new NotiSetting(this.moduleData);

        btnSetting?.addEventListener('click', e => {
            const notiSetting = document.querySelector('#notiSetting');
            const notiList = document.querySelector('#notiList');

            if(notiSetting) notiSetting.style.display = 'block';
            if(notiList) notiList.style.display = 'none';

            this._notisetting.start();
        });

        if (this.moduleData.userData.isLogin) {
            this.loadNotiCount();
        }
    }

    loadNotiCount() {
        const apiData = window.notiDummyData || api;

        getJsonp({
            url: apiData.count,
            params: {
                'targetCategory[]': 'GNB_NOTI'
            }
        })
        .then(res => {
            const result = res?.result;
            const { returnMessage, notiResult } = result || {};
            const { countList = [] } = notiResult || {};

            if(returnMessage === 'SUCCESS' && countList.length > 0) {
                const countNum = parseInt(countList[0]?.notiCount) || 0;
                const isShow = countNum > 0;

                if (isShow) {
                    const loginInfoSpan = document.querySelectorAll('#nc-cnb .ncc-login .ncc-login--info__noti span');
                    const notiTabSpan = document.querySelectorAll('#nc-cnb .ncc-noti-tab a span');
                    const notiAlarmCount = document.querySelectorAll('.ncc-login--user-btn .noti-alarm-count');
                    const targetArr = [...loginInfoSpan, ...notiTabSpan, ...notiAlarmCount];
                    const num = countNum > 99 ? '99+' : countNum;

                    targetArr.forEach(target => {
                        if(target) {
                            target.innerText = num;
                            target.style.display = 'inline-block';
                        }
                    });
                } else {
                    this.notiCountNumHide();
                }
            } else {
                this.notiCountNumHide();
            }
        })
        .catch(err => {
            console.log(`${apiData.count} 호출에 실패했습니다.`, err);
            this.notiCountNumHide();
        });
    }

    notiCountNumHide() {
        const loginInfoSpan = document.querySelector('#nc-cnb .ncc-login .ncc-login--info__noti span');
        const notiTabSpan = document.querySelector('#nc-cnb .ncc-noti-tab a span');
        const notiAlarmCount = document.querySelector('.ncc-login--user-btn .noti-alarm-count');
        const targetArr = [loginInfoSpan, notiTabSpan, notiAlarmCount];
        const num = 0;
        
        targetArr.forEach(target => {
            if(target) {
                target.innerText = num;
                target.style.display = 'none';
            }
        });
    }

    makeMarkup() {
        return `
        <div class="ncc-noti">
            <div class="ncc-noti-list" id="notiList">
                <div class="wrap_btns"><button class="imgBtn btnSetting">${this.com.l10nData.Notifications.NotificationsSettings}</button></div>
            </div>
            <div class="ncc-noti-setting" id="notiSetting" style="display: none;">
            </div>
        </div>
        `;
    }
}

export default Noti;